import script from "./MResultModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MResultModal.vue?vue&type=script&setup=true&lang=ts"

import "./MResultModal.vue?vue&type=style&index=0&id=e1331d42&lang=less"

const __exports__ = script;

export default __exports__